export const Meditation = {
    initialData: 'meditation.initial-data',
};



// WEBPACK FOOTER //
// ./scripts/frontend/meditations/actions.js